import { storyblokEditable } from "@storyblok/react";
import { LetterText } from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router";

export const FeaturedPosts = ({ blok }) => {
  return (
    <section {...storyblokEditable(blok)} className="featured-posts">
      <div className="featured-posts-intro">
        <div className="posts-icon-wrapper">
          <LetterText className="things-icon" size={32} />
          <h2>Featured blog posts</h2>
        </div>

        <p>Strategy. Inspiration. Tools. Results.</p>
      </div>
      <ul>
        {blok.blogposts.map((post) => (
          <li key={post.uuid}>
            <div className="article-meta">
              <div className="image-wrap">
                <img src={post.content.featuredimage.filename} />
              </div>
              <h4>{post.name}</h4>
              <div className="date">{post.content.published_at}</div>
              <p>{post.content.summary}</p>
              <Link to={`/${post.full_slug}`}>{/* post.name */}Read more</Link>
            </div>
          </li>
        ))}
      </ul>
      <a href="/blog" className="button button-primary">
        View all blog posts{" "}
        <ArrowRight size={24} fill="white" className="button-icon" />
      </a>
    </section>
  );
};
